import { render, staticRenderFns } from "./Dedication.vue?vue&type=template&id=7be89bf8&scoped=true&lang=pug&"
import script from "./Dedication.vue?vue&type=script&lang=js&"
export * from "./Dedication.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7be89bf8",
  null
  
)

export default component.exports